"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalBar = VerticalBar;

var _shared = require("@clayui/shared");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Bar = require("./Bar");

var _Content = require("./Content");

var _Item = require("./Item");

var _Panel = require("./Panel");

var _context = require("./context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function VerticalBar(_ref) {
  var _ref$absolute = _ref.absolute,
      absolute = _ref$absolute === void 0 ? false : _ref$absolute,
      _ref$activation = _ref.activation,
      activation = _ref$activation === void 0 ? 'manual' : _ref$activation,
      active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      _ref$defaultActive = _ref.defaultActive,
      defaultActive = _ref$defaultActive === void 0 ? null : _ref$defaultActive,
      onActiveChange = _ref.onActiveChange,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'right' : _ref$position;

  var _useInternalState = (0, _shared.useInternalState)({
    defaultName: 'defaultItems',
    defaultValue: defaultActive,
    handleName: 'onActiveChange',
    name: 'active',
    onChange: onActiveChange,
    value: active
  }),
      _useInternalState2 = _slicedToArray(_useInternalState, 2),
      activePanel = _useInternalState2[0],
      setActivePanel = _useInternalState2[1];

  var id = (0, _shared.useId)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('c-slideout c-slideout-shown', className, {
      'c-slideout-absolute': absolute,
      'c-slideout-end': position === 'right',
      'c-slideout-fixed': !absolute,
      'c-slideout-start sidenav-start': position === 'left'
    })
  }, /*#__PURE__*/_react.default.createElement(_context.VerticalBarContext.Provider, {
    value: {
      activation: activation,
      activePanel: activePanel,
      id: "".concat(id, "-verticalbar"),
      onActivePanel: setActivePanel
    }
  }, children));
}

VerticalBar.Bar = _Bar.Bar;
VerticalBar.Content = _Content.Content;
VerticalBar.Item = _Item.Item;
VerticalBar.Panel = _Panel.Panel;